import { svg } from './circle.module.scss';

export const Circle = (prop: { position: string }) => <div className={`${svg} ${prop.position}`}></div>;
